import { render, staticRenderFns } from "./SitesClients.vue?vue&type=template&id=d5255d4e&scoped=true"
import script from "./SitesClients.vue?vue&type=script&lang=js"
export * from "./SitesClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5255d4e",
  null
  
)

export default component.exports